import { CatalogueItem, CategoryNode, ItemRef, ProductColumn } from './catalogueTypes'
import { refersTo } from './catalogueUrls'

export const NAME_COLUMN = 'name'

export const categoriesOf = (items: CatalogueItem[]): CategoryNode[] =>
  items.filter((item): item is CategoryNode => item.class_name === 'ProductCategory')

export const findCategory = (categories: CategoryNode[], id: number | null): CategoryNode | null => {
  if (id === null) return null
  for (const category of categories) {
    if (category.id === id) return category
    const nested = findCategory(categoriesOf(category.children), id)
    if (nested) return nested
  }
  return null
}

const findInItems = (items: CatalogueItem[], ref: ItemRef): CatalogueItem | null => {
  for (const item of items) {
    if (refersTo(ref, item)) return item
    if (item.class_name === 'ProductCategory') {
      const nested = findInItems(item.children, ref)
      if (nested) return nested
    }
  }
  return null
}

export const findItem = (rows: CatalogueItem[], roots: CategoryNode[], ref: ItemRef): CatalogueItem | null =>
  findInItems(rows, ref) ?? findInItems(roots, ref)

export const withoutItem = <T extends CatalogueItem>(items: T[], removed: CatalogueItem): T[] =>
  items
    .filter((item) => !(item.id === removed.id && item.class_name === removed.class_name))
    .map((item) =>
      item.class_name === 'ProductCategory' ? { ...item, children: withoutItem(item.children, removed) } : item
    )

export const rootIdOf = (category: CategoryNode | null): number | null =>
  category && category.ancestry.length > 0 ? category.ancestry[0].id : null

export const selectedColumns = (columns: ProductColumn[]): ProductColumn[] => columns.filter((column) => column.selected)

export const nameColumnSpan = (columns: ProductColumn[]): number =>
  columns.filter((column) => !column.selected).length + 1

export const selectableColumns = (columns: ProductColumn[]): ProductColumn[] =>
  columns.filter((column) => !column.mandatory)
